/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ActivityProgression,
  ApiError,
  Challenge,
  ChallengeBody,
  ChallengeCommunityGoalResponse,
  ChallengeDashboardResponse,
  ChallengeInfoResponse,
  ChallengeMemberStatusResponse,
  ChallengeMyRankResponse,
  ChallengePrizeBody,
  ChallengeRealmCountryResponse,
  ChallengeRegisterRequest,
  ChallengeRegisterResponse,
  ChallengeShowcasePhotosResponse,
  ChallengeSummaryResponse,
  ChallengesListResponse,
  CompleteChallengeProfileBody,
  CompleteChallengeProfileResponse,
  DistributeWinnerBody,
  DistributeWinnerResponse,
  DrawType,
  FormError,
  GetChallengeSlugOwnReferralCodeResponse,
  GetChallengesResponse,
  GetChallengesSort,
  GetDrawLogsResponse,
  OWReward,
  PostChallengeSlugReferralsOwnCodeRequest,
  PostChallengeSlugReferralsOwnCodeResponse,
  PrizePool,
  RealmSigninBody,
  RedrawChallengePrizeBody,
  ResetChallengePrizeBody,
  RttrClaimSocialFollowRequest,
  RttrClaimSocialFollowResponse,
  RttrClaimSocialLikeBody,
  RttrClaimSocialLikeResponse,
  RttrFinalistsResponse,
  RttrInviteBody,
  RttrInviteResponse,
  RttrPostSubmitRequest,
  RttrPostSubmitResponse,
  RttrQrRedeemRequest,
  RttrQrRedeemResponse,
  RttrSerialVerifyRequest,
  RttrSerialVerifyResponse,
  RttrStandingsResponse,
  RttrUserStateResponse,
  SegmentUnlockCodeResponse,
  SortOrder,
  SubmitChallengeResponseBody,
  SubmitChallengeResponseResult,
  Token,
  TriggerChallengeDistributionBody,
  UpdateUserChallengeMembershipBody,
} from '../models/index';
import {
    ActivityProgressionFromJSON,
    ActivityProgressionToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    ChallengeFromJSON,
    ChallengeToJSON,
    ChallengeBodyFromJSON,
    ChallengeBodyToJSON,
    ChallengeCommunityGoalResponseFromJSON,
    ChallengeCommunityGoalResponseToJSON,
    ChallengeDashboardResponseFromJSON,
    ChallengeDashboardResponseToJSON,
    ChallengeInfoResponseFromJSON,
    ChallengeInfoResponseToJSON,
    ChallengeMemberStatusResponseFromJSON,
    ChallengeMemberStatusResponseToJSON,
    ChallengeMyRankResponseFromJSON,
    ChallengeMyRankResponseToJSON,
    ChallengePrizeBodyFromJSON,
    ChallengePrizeBodyToJSON,
    ChallengeRealmCountryResponseFromJSON,
    ChallengeRealmCountryResponseToJSON,
    ChallengeRegisterRequestFromJSON,
    ChallengeRegisterRequestToJSON,
    ChallengeRegisterResponseFromJSON,
    ChallengeRegisterResponseToJSON,
    ChallengeShowcasePhotosResponseFromJSON,
    ChallengeShowcasePhotosResponseToJSON,
    ChallengeSummaryResponseFromJSON,
    ChallengeSummaryResponseToJSON,
    ChallengesListResponseFromJSON,
    ChallengesListResponseToJSON,
    CompleteChallengeProfileBodyFromJSON,
    CompleteChallengeProfileBodyToJSON,
    CompleteChallengeProfileResponseFromJSON,
    CompleteChallengeProfileResponseToJSON,
    DistributeWinnerBodyFromJSON,
    DistributeWinnerBodyToJSON,
    DistributeWinnerResponseFromJSON,
    DistributeWinnerResponseToJSON,
    DrawTypeFromJSON,
    DrawTypeToJSON,
    FormErrorFromJSON,
    FormErrorToJSON,
    GetChallengeSlugOwnReferralCodeResponseFromJSON,
    GetChallengeSlugOwnReferralCodeResponseToJSON,
    GetChallengesResponseFromJSON,
    GetChallengesResponseToJSON,
    GetChallengesSortFromJSON,
    GetChallengesSortToJSON,
    GetDrawLogsResponseFromJSON,
    GetDrawLogsResponseToJSON,
    OWRewardFromJSON,
    OWRewardToJSON,
    PostChallengeSlugReferralsOwnCodeRequestFromJSON,
    PostChallengeSlugReferralsOwnCodeRequestToJSON,
    PostChallengeSlugReferralsOwnCodeResponseFromJSON,
    PostChallengeSlugReferralsOwnCodeResponseToJSON,
    PrizePoolFromJSON,
    PrizePoolToJSON,
    RealmSigninBodyFromJSON,
    RealmSigninBodyToJSON,
    RedrawChallengePrizeBodyFromJSON,
    RedrawChallengePrizeBodyToJSON,
    ResetChallengePrizeBodyFromJSON,
    ResetChallengePrizeBodyToJSON,
    RttrClaimSocialFollowRequestFromJSON,
    RttrClaimSocialFollowRequestToJSON,
    RttrClaimSocialFollowResponseFromJSON,
    RttrClaimSocialFollowResponseToJSON,
    RttrClaimSocialLikeBodyFromJSON,
    RttrClaimSocialLikeBodyToJSON,
    RttrClaimSocialLikeResponseFromJSON,
    RttrClaimSocialLikeResponseToJSON,
    RttrFinalistsResponseFromJSON,
    RttrFinalistsResponseToJSON,
    RttrInviteBodyFromJSON,
    RttrInviteBodyToJSON,
    RttrInviteResponseFromJSON,
    RttrInviteResponseToJSON,
    RttrPostSubmitRequestFromJSON,
    RttrPostSubmitRequestToJSON,
    RttrPostSubmitResponseFromJSON,
    RttrPostSubmitResponseToJSON,
    RttrQrRedeemRequestFromJSON,
    RttrQrRedeemRequestToJSON,
    RttrQrRedeemResponseFromJSON,
    RttrQrRedeemResponseToJSON,
    RttrSerialVerifyRequestFromJSON,
    RttrSerialVerifyRequestToJSON,
    RttrSerialVerifyResponseFromJSON,
    RttrSerialVerifyResponseToJSON,
    RttrStandingsResponseFromJSON,
    RttrStandingsResponseToJSON,
    RttrUserStateResponseFromJSON,
    RttrUserStateResponseToJSON,
    SegmentUnlockCodeResponseFromJSON,
    SegmentUnlockCodeResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    SubmitChallengeResponseBodyFromJSON,
    SubmitChallengeResponseBodyToJSON,
    SubmitChallengeResponseResultFromJSON,
    SubmitChallengeResponseResultToJSON,
    TokenFromJSON,
    TokenToJSON,
    TriggerChallengeDistributionBodyFromJSON,
    TriggerChallengeDistributionBodyToJSON,
    UpdateUserChallengeMembershipBodyFromJSON,
    UpdateUserChallengeMembershipBodyToJSON,
} from '../models/index';

export interface CreateChallengesRequest {
    challengeBody?: ChallengeBody;
}

export interface CreateChallengesDistributeIdRequest {
    id: string;
    triggerChallengeDistributionBody?: TriggerChallengeDistributionBody;
}

export interface CreateChallengesDistributeIdDrawLogRequest {
    id: string;
    body?: object;
}

export interface CreateChallengesDrawLogIdDistributeWinnerRequest {
    id: string;
    distributeWinnerBody: DistributeWinnerBody;
}

export interface CreateChallengesIdAcceptRequest {
    id: string;
}

export interface CreateChallengesIdDuplicateRequest {
    id: string;
}

export interface CreateChallengesIdGrandPrizeDrawRequest {
    id: string;
    body?: object;
}

export interface CreateChallengesIdResponseRequest {
    id: string;
    submitChallengeResponseBody: SubmitChallengeResponseBody;
}

export interface CreateChallengesPrizesRequest {
    challengePrizeBody?: ChallengePrizeBody;
}

export interface CreateChallengesSlugCompleteProfileRequest {
    slug: string;
    completeChallengeProfileBody?: CompleteChallengeProfileBody;
}

export interface CreateChallengesSlugOnboardingCompleteRequest {
    slug: string;
}

export interface CreateChallengesSlugRealmSigninRequest {
    slug: string;
    xRealmUUID: string;
    xRealmTS: string;
    xRealmSig: string;
    realmSigninBody?: RealmSigninBody;
}

export interface CreateChallengesSlugReferralsOwnCodeRequest {
    slug: string;
    postChallengeSlugReferralsOwnCodeRequest?: PostChallengeSlugReferralsOwnCodeRequest;
}

export interface CreateChallengesSlugRegisterRequest {
    slug: string;
    challengeRegisterRequest: ChallengeRegisterRequest;
    xRealmUUID?: string;
    xRealmTS?: string;
    xRealmSig?: string;
}

export interface CreateChallengesSlugRttrClaimSocialFollowRequest {
    slug: string;
    rttrClaimSocialFollowRequest?: RttrClaimSocialFollowRequest;
}

export interface CreateChallengesSlugRttrClaimSocialLikeRequest {
    slug: string;
    rttrClaimSocialLikeBody: RttrClaimSocialLikeBody;
}

export interface CreateChallengesSlugRttrInviteRequest {
    slug: string;
    rttrInviteBody: RttrInviteBody;
}

export interface CreateChallengesSlugRttrPostSubmitRequest {
    slug: string;
    rttrPostSubmitRequest: RttrPostSubmitRequest;
}

export interface CreateChallengesSlugRttrQrRedeemRequest {
    slug: string;
    rttrQrRedeemRequest: RttrQrRedeemRequest;
}

export interface CreateChallengesSlugRttrSerialVerifyRequest {
    slug: string;
    rttrSerialVerifyRequest: RttrSerialVerifyRequest;
}

export interface DeleteChallengesDistributeIdRequest {
    id: string;
    resetChallengePrizeBody?: ResetChallengePrizeBody;
}

export interface DeleteChallengesDrawLogIdRequest {
    id: string;
}

export interface DeleteChallengesIdRequest {
    id: string;
}

export interface DeleteChallengesProgressIdRequest {
    id: string;
}

export interface GetChallengeDashboardIdRequest {
    id: string;
}

export interface GetChallengeDrawLogsRequest {
    challengeId?: string;
    drawType?: DrawType;
    limit?: number;
    offset?: number;
}

export interface GetChallengeDrawLogsIdExportRequest {
    id: string;
}

export interface GetChallengePrizesWonRequest {
    newPrizesOnly?: boolean;
}

export interface GetChallengeUserReportRequest {
    challengeId: string;
    format?: GetChallengeUserReportFormatEnum;
    limit?: number;
    offset?: number;
    search?: string;
}

export interface GetChallengesRequest {
    userId?: string;
    search?: string;
    sort?: GetChallengesSort;
    order?: SortOrder;
    unassignedOnly?: boolean;
    allowNonActives?: boolean;
    brandMap?: string;
    includeExpired?: boolean;
    brandId?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetChallengesGetInfoRequest {
    slug?: string;
    challengeId?: string;
}

export interface GetChallengesIdQuestsRequest {
    id: string;
    onlyActive?: boolean;
}

export interface GetChallengesSlugCommunityGoalRequest {
    slug: string;
}

export interface GetChallengesSlugFinalistsRequest {
    slug: string;
}

export interface GetChallengesSlugMemberStatusRequest {
    slug: string;
    xRealmUUID: string;
    xRealmTS: string;
    xRealmSig: string;
}

export interface GetChallengesSlugMyProgressionRequest {
    slug: string;
}

export interface GetChallengesSlugMyRankRequest {
    slug: string;
    segment?: number;
    scope?: GetChallengesSlugMyRankScopeEnum;
}

export interface GetChallengesSlugRealmCountryRequest {
    slug: string;
    xRealmUUID: string;
    xRealmTS: string;
    xRealmSig: string;
}

export interface GetChallengesSlugReferralsOwnCodeRequest {
    slug: string;
}

export interface GetChallengesSlugRttrUserStateRequest {
    slug: string;
}

export interface GetChallengesSlugSegmentsSegmentIndexUnlockCodeRequest {
    slug: string;
    segmentIndex: string;
}

export interface GetChallengesSlugShowcasePhotosRequest {
    slug: string;
}

export interface GetChallengesSlugStandingsRequest {
    slug: string;
    segment?: number;
    limit?: number;
    offset?: number;
    scope?: GetChallengesSlugStandingsScopeEnum;
}

export interface GetChallengesSummaryIdRequest {
    id: string;
    userIds?: Array<string>;
}

export interface UpdateChallengesDrawLogIdRedrawRequest {
    id: string;
    redrawChallengePrizeBody?: RedrawChallengePrizeBody;
}

export interface UpdateChallengesIdRequest {
    id: string;
    challengeBody?: ChallengeBody;
}

export interface UpdateChallengesIdMembershipRequest {
    id: string;
    updateUserChallengeMembershipBody?: UpdateUserChallengeMembershipBody;
}

export interface UpdateChallengesPrizesIdRequest {
    id: string;
    challengePrizeBody?: ChallengePrizeBody;
}

export interface UpdateConfirmNotifyPrizeWonIdRequest {
    id: string;
    body?: object;
}

/**
 * ChallengesApi - interface
 * 
 * @export
 * @interface ChallengesApiInterface
 */
export interface ChallengesApiInterface {
    /**
     * Create a new Challenge
     * @param {ChallengeBody} [challengeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesRaw(requestParameters: CreateChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>>;

    /**
     * Create a new Challenge
     */
    createChallenges(requestParameters: CreateChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge>;

    /**
     * Manually distribute a challenge prize
     * @param {string} id 
     * @param {TriggerChallengeDistributionBody} [triggerChallengeDistributionBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesDistributeIdRaw(requestParameters: CreateChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Manually distribute a challenge prize
     */
    createChallengesDistributeId(requestParameters: CreateChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Manually distribute prizes based on specified draw log
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesDistributeIdDrawLogRaw(requestParameters: CreateChallengesDistributeIdDrawLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Manually distribute prizes based on specified draw log
     */
    createChallengesDistributeIdDrawLog(requestParameters: CreateChallengesDistributeIdDrawLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Distribute the prize for a single winner on a CHALLENGE_DRAW log. Per-winner alternative to the bulk distribute endpoint so admins can verify + ship one winner at a time.
     * @param {string} id 
     * @param {DistributeWinnerBody} distributeWinnerBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesDrawLogIdDistributeWinnerRaw(requestParameters: CreateChallengesDrawLogIdDistributeWinnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributeWinnerResponse>>;

    /**
     * Distribute the prize for a single winner on a CHALLENGE_DRAW log. Per-winner alternative to the bulk distribute endpoint so admins can verify + ship one winner at a time.
     */
    createChallengesDrawLogIdDistributeWinner(requestParameters: CreateChallengesDrawLogIdDistributeWinnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributeWinnerResponse>;

    /**
     * Create a new challenge membership for a user when they accept a challenge
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesIdAcceptRaw(requestParameters: CreateChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Create a new challenge membership for a user when they accept a challenge
     */
    createChallengesIdAccept(requestParameters: CreateChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Duplicate an existing challenge with fresh prize pools
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesIdDuplicateRaw(requestParameters: CreateChallengesIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>>;

    /**
     * Duplicate an existing challenge with fresh prize pools
     */
    createChallengesIdDuplicate(requestParameters: CreateChallengesIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge>;

    /**
     * Manually trigger the Grand Prize drawing for a challenge
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesIdGrandPrizeDrawRaw(requestParameters: CreateChallengesIdGrandPrizeDrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>>;

    /**
     * Manually trigger the Grand Prize drawing for a challenge
     */
    createChallengesIdGrandPrizeDraw(requestParameters: CreateChallengesIdGrandPrizeDrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge>;

    /**
     * Submit user response to challenge-specific questions (newsletter opt-in, etc.)
     * @param {string} id 
     * @param {SubmitChallengeResponseBody} submitChallengeResponseBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesIdResponseRaw(requestParameters: CreateChallengesIdResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitChallengeResponseResult>>;

    /**
     * Submit user response to challenge-specific questions (newsletter opt-in, etc.)
     */
    createChallengesIdResponse(requestParameters: CreateChallengesIdResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitChallengeResponseResult>;

    /**
     * Create a new Challenge prize
     * @param {ChallengePrizeBody} [challengePrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesPrizesRaw(requestParameters: CreateChallengesPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizePool>>;

    /**
     * Create a new Challenge prize
     */
    createChallengesPrizes(requestParameters: CreateChallengesPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizePool>;

    /**
     * Fills in attestation + geo fields on an existing ChallengeMembership for a user with myMembershipNeedsCompletion=true. Setters-only — never overwrites existing values.
     * @param {string} slug 
     * @param {CompleteChallengeProfileBody} [completeChallengeProfileBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugCompleteProfileRaw(requestParameters: CreateChallengesSlugCompleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteChallengeProfileResponse>>;

    /**
     * Fills in attestation + geo fields on an existing ChallengeMembership for a user with myMembershipNeedsCompletion=true. Setters-only — never overwrites existing values.
     */
    createChallengesSlugCompleteProfile(requestParameters: CreateChallengesSlugCompleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteChallengeProfileResponse>;

    /**
     * Flips ChallengeMembership.onboardingComplete to true for the authenticated user + the challenge with the given slug. Idempotent. Called on Submit OR Skip from branded onboarding modals. Gates the per-login auto-pop of the onboarding modal — once true, hub mounts directly without surfacing the modal again. Profile-edit drawer remains the always-on access path for avatar/nickname changes. 
     * @summary Mark the authenticated user\'s challenge-scoped onboarding flow as complete
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugOnboardingCompleteRaw(requestParameters: CreateChallengesSlugOnboardingCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Flips ChallengeMembership.onboardingComplete to true for the authenticated user + the challenge with the given slug. Idempotent. Called on Submit OR Skip from branded onboarding modals. Gates the per-login auto-pop of the onboarding modal — once true, hub mounts directly without surfacing the modal again. Profile-edit drawer remains the always-on access path for avatar/nickname changes. 
     * Mark the authenticated user\'s challenge-scoped onboarding flow as complete
     */
    createChallengesSlugOnboardingComplete(requestParameters: CreateChallengesSlugOnboardingCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Authenticates a Realm user via the signed X-Realm handshake without an email verification code, pulling the verified email from the Minelab Users Core Service to find-or-create the DevourPlay account. Returns 422 when Realm has no email on file so the client can fall back to email + code. The caller should follow up with POST /challenges/{slug}/register (authenticated) to record terms + declared geo and bind the realmUuid.
     * @summary Codeless Realm sign-in (mints a session from a verified embed)
     * @param {string} slug Challenge slug (e.g. \&quot;minelab-rttr\&quot;).
     * @param {string} xRealmUUID Realm user id from the signed handoff.
     * @param {string} xRealmTS 10-digit Unix-seconds timestamp of the handoff signature.
     * @param {string} xRealmSig HMAC-SHA256 signature of the handoff.
     * @param {RealmSigninBody} [realmSigninBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRealmSigninRaw(requestParameters: CreateChallengesSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>>;

    /**
     * Authenticates a Realm user via the signed X-Realm handshake without an email verification code, pulling the verified email from the Minelab Users Core Service to find-or-create the DevourPlay account. Returns 422 when Realm has no email on file so the client can fall back to email + code. The caller should follow up with POST /challenges/{slug}/register (authenticated) to record terms + declared geo and bind the realmUuid.
     * Codeless Realm sign-in (mints a session from a verified embed)
     */
    createChallengesSlugRealmSignin(requestParameters: CreateChallengesSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token>;

    /**
     * Sets the authenticated user\'s challenge-scoped referral code. Pass a custom string in the body to claim a vanity code (uniqueness checked server-side, 409 on collision). Pass an empty body to regenerate the auto-gen code — useful when the challenge\'s referralCodePrefix has changed and the user wants the new branded format. 
     * @summary Claim a custom challenge-scoped referral code or regenerate an auto-gen code
     * @param {string} slug 
     * @param {PostChallengeSlugReferralsOwnCodeRequest} [postChallengeSlugReferralsOwnCodeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugReferralsOwnCodeRaw(requestParameters: CreateChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostChallengeSlugReferralsOwnCodeResponse>>;

    /**
     * Sets the authenticated user\'s challenge-scoped referral code. Pass a custom string in the body to claim a vanity code (uniqueness checked server-side, 409 on collision). Pass an empty body to regenerate the auto-gen code — useful when the challenge\'s referralCodePrefix has changed and the user wants the new branded format. 
     * Claim a custom challenge-scoped referral code or regenerate an auto-gen code
     */
    createChallengesSlugReferralsOwnCode(requestParameters: CreateChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostChallengeSlugReferralsOwnCodeResponse>;

    /**
     * Records the user\'s acceptance of terms and any per-challenge eligibility checkboxes, and links a Realm UUID to the User if X-Realm-UUID header is present. Required for earning points on challenges that have eligibilityCheckboxes configured.
     * @summary Complete challenge registration with eligibility attestations
     * @param {string} slug 
     * @param {ChallengeRegisterRequest} challengeRegisterRequest 
     * @param {string} [xRealmUUID] Optional Realm app UUID. When present, attached to the User record as User.realmUuid for marketing segregation. Must be accompanied by X-Realm-TS and X-Realm-Sig.
     * @param {string} [xRealmTS] Unix timestamp (seconds) when the signed handoff was generated. Required when X-Realm-UUID is present. Must be within ±15 minutes of server time (HANDOFF_TS_MAX_SKEW_SECONDS).
     * @param {string} [xRealmSig] HMAC-SHA256 signature of the canonical string using the shared realm-handoff-secret, hex-encoded. Required when X-Realm-UUID is present. Spec canonical string is &#x60;${realm_uuid}|${ts}&#x60; (pipe-separated). As of 2026-05-12 the handler ALSO accepts &#x60;${realm_uuid}${ts}&#x60; (concatenated, no separator) as a tactical bandaid because Realm\&#39;s TestFlight build ships a non-spec HMAC — see handler comment for removal criteria (TODO realm-hmac-fix).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRegisterRaw(requestParameters: CreateChallengesSlugRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeRegisterResponse>>;

    /**
     * Records the user\'s acceptance of terms and any per-challenge eligibility checkboxes, and links a Realm UUID to the User if X-Realm-UUID header is present. Required for earning points on challenges that have eligibilityCheckboxes configured.
     * Complete challenge registration with eligibility attestations
     */
    createChallengesSlugRegister(requestParameters: CreateChallengesSlugRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeRegisterResponse>;

    /**
     * Honor-system claim — one per user per round. Platform and points are determined by the active segment.
     * @summary Claim points for following the active round\'s Minelab social channel
     * @param {string} slug 
     * @param {RttrClaimSocialFollowRequest} [rttrClaimSocialFollowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrClaimSocialFollowRaw(requestParameters: CreateChallengesSlugRttrClaimSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrClaimSocialFollowResponse>>;

    /**
     * Honor-system claim — one per user per round. Platform and points are determined by the active segment.
     * Claim points for following the active round\'s Minelab social channel
     */
    createChallengesSlugRttrClaimSocialFollow(requestParameters: CreateChallengesSlugRttrClaimSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrClaimSocialFollowResponse>;

    /**
     * Honor-system claim — one per user per post per round. Active platform is determined server-side from the segment index. Idempotent via the unique compound index — repeat calls with the same normalized postUrl return 409.
     * @summary Claim points for liking a specific Minelab social post during the active round
     * @param {string} slug 
     * @param {RttrClaimSocialLikeBody} rttrClaimSocialLikeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrClaimSocialLikeRaw(requestParameters: CreateChallengesSlugRttrClaimSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrClaimSocialLikeResponse>>;

    /**
     * Honor-system claim — one per user per post per round. Active platform is determined server-side from the segment index. Idempotent via the unique compound index — repeat calls with the same normalized postUrl return 409.
     * Claim points for liking a specific Minelab social post during the active round
     */
    createChallengesSlugRttrClaimSocialLike(requestParameters: CreateChallengesSlugRttrClaimSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrClaimSocialLikeResponse>;

    /**
     * Sends the Grow the Realm invite email and credits the inviter on a confirmed send. Cap of 3 rewarded referrals per round, shared with code-signup referrals.
     * @summary Email a friend an invitation to join Race to the Realm
     * @param {string} slug 
     * @param {RttrInviteBody} rttrInviteBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrInviteRaw(requestParameters: CreateChallengesSlugRttrInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrInviteResponse>>;

    /**
     * Sends the Grow the Realm invite email and credits the inviter on a confirmed send. Cap of 3 rewarded referrals per round, shared with code-signup referrals.
     * Email a friend an invitation to join Race to the Realm
     */
    createChallengesSlugRttrInvite(requestParameters: CreateChallengesSlugRttrInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrInviteResponse>;

    /**
     * Awards RTTR points for the active round. Max 3 posts per round. TikTok posts are verified by Apify scraper (handles /video/ and /photo/ canonical URLs, resolves /t/ share short links via redirect-follow). Instagram posts are verified via Browserless (loads the public post page and reads the caption from og:description, since Apify\'s IG scraper is blocked at our egress). Facebook posts are verified by Apify scraper. 
     * @summary Submit an
     * @param {string} slug 
     * @param {RttrPostSubmitRequest} rttrPostSubmitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrPostSubmitRaw(requestParameters: CreateChallengesSlugRttrPostSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrPostSubmitResponse>>;

    /**
     * Awards RTTR points for the active round. Max 3 posts per round. TikTok posts are verified by Apify scraper (handles /video/ and /photo/ canonical URLs, resolves /t/ share short links via redirect-follow). Instagram posts are verified via Browserless (loads the public post page and reads the caption from og:description, since Apify\'s IG scraper is blocked at our egress). Facebook posts are verified by Apify scraper. 
     * Submit an
     */
    createChallengesSlugRttrPostSubmit(requestParameters: CreateChallengesSlugRttrPostSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrPostSubmitResponse>;

    /**
     * Awards points for attending an RTTR event. One redemption per user per round per eventType — MineLab and Club tracks are independent.
     * @summary Redeem an RTTR event QR code
     * @param {string} slug 
     * @param {RttrQrRedeemRequest} rttrQrRedeemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrQrRedeemRaw(requestParameters: CreateChallengesSlugRttrQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrQrRedeemResponse>>;

    /**
     * Awards points for attending an RTTR event. One redemption per user per round per eventType — MineLab and Club tracks are independent.
     * Redeem an RTTR event QR code
     */
    createChallengesSlugRttrQrRedeem(requestParameters: CreateChallengesSlugRttrQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrQrRedeemResponse>;

    /**
     * Looks up the serial in Minelab\'s HubSpot Product Registrations object, resolves the product to a tier, and awards points (capped per user). New purchases earn tier-based points up to 16k total; existing registrations earn 3k each up to 3 claims / 9k total.
     * @summary Verify a Minelab product serial and award RTTR points
     * @param {string} slug 
     * @param {RttrSerialVerifyRequest} rttrSerialVerifyRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    createChallengesSlugRttrSerialVerifyRaw(requestParameters: CreateChallengesSlugRttrSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrSerialVerifyResponse>>;

    /**
     * Looks up the serial in Minelab\'s HubSpot Product Registrations object, resolves the product to a tier, and awards points (capped per user). New purchases earn tier-based points up to 16k total; existing registrations earn 3k each up to 3 claims / 9k total.
     * Verify a Minelab product serial and award RTTR points
     */
    createChallengesSlugRttrSerialVerify(requestParameters: CreateChallengesSlugRttrSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrSerialVerifyResponse>;

    /**
     * Manually reset a challenge prize as if it never distributed yet.
     * @param {string} id 
     * @param {ResetChallengePrizeBody} [resetChallengePrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    deleteChallengesDistributeIdRaw(requestParameters: DeleteChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Manually reset a challenge prize as if it never distributed yet.
     */
    deleteChallengesDistributeId(requestParameters: DeleteChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Manually delete a dry run draw log.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    deleteChallengesDrawLogIdRaw(requestParameters: DeleteChallengesDrawLogIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Manually delete a dry run draw log.
     */
    deleteChallengesDrawLogId(requestParameters: DeleteChallengesDrawLogIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Remove a specific challenge and any associated challengeMemberships
     * @param {string} id ID of the challenge to remove
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    deleteChallengesIdRaw(requestParameters: DeleteChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Remove a specific challenge and any associated challengeMemberships
     */
    deleteChallengesId(requestParameters: DeleteChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Delete all users progress for all quests for a specific challenge.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    deleteChallengesProgressIdRaw(requestParameters: DeleteChallengesProgressIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete all users progress for all quests for a specific challenge.
     */
    deleteChallengesProgressId(requestParameters: DeleteChallengesProgressIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get aggregated dashboard stats for a challenge including segment and milestone completion rates
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengeDashboardIdRaw(requestParameters: GetChallengeDashboardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeDashboardResponse>>;

    /**
     * Get aggregated dashboard stats for a challenge including segment and milestone completion rates
     */
    getChallengeDashboardId(requestParameters: GetChallengeDashboardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeDashboardResponse>;

    /**
     * Get audit logs for challenge prize drawings
     * @param {string} [challengeId] Filter by challenge ID
     * @param {DrawType} [drawType] Filter by draw type
     * @param {number} [limit] Number of results to return (default 50)
     * @param {number} [offset] Offset for pagination
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengeDrawLogsRaw(requestParameters: GetChallengeDrawLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDrawLogsResponse>>;

    /**
     * Get audit logs for challenge prize drawings
     */
    getChallengeDrawLogs(requestParameters: GetChallengeDrawLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDrawLogsResponse>;

    /**
     * Export a single draw log as JSON for audit purposes
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengeDrawLogsIdExportRaw(requestParameters: GetChallengeDrawLogsIdExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Export a single draw log as JSON for audit purposes
     */
    getChallengeDrawLogsIdExport(requestParameters: GetChallengeDrawLogsIdExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Fetch all challenge prizes won by the user
     * @param {boolean} [newPrizesOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengePrizesWonRaw(requestParameters: GetChallengePrizesWonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrizePool>>>;

    /**
     * Fetch all challenge prizes won by the user
     */
    getChallengePrizesWon(requestParameters: GetChallengePrizesWonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrizePool>>;

    /**
     * Get detailed user report for a challenge including entries and prizes
     * @param {string} challengeId 
     * @param {'json' | 'csv'} [format] Response format (default json)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [search] Search by email or username
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengeUserReportRaw(requestParameters: GetChallengeUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Get detailed user report for a challenge including entries and prizes
     */
    getChallengeUserReport(requestParameters: GetChallengeUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Get list of all challenges with user acceptance status
     * @param {string} [userId] 
     * @param {string} [search] 
     * @param {GetChallengesSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {boolean} [unassignedOnly] 
     * @param {boolean} [allowNonActives] 
     * @param {string} [brandMap] The slug of the brand map to filter challenges by
     * @param {boolean} [includeExpired] Include challenges that ended more than 7 days ago (default false)
     * @param {string} [brandId] Filter challenges by brand ID
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesRaw(requestParameters: GetChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengesResponse>>;

    /**
     * Get list of all challenges with user acceptance status
     */
    getChallenges(requestParameters: GetChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengesResponse>;

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     * @param {string} [slug] 
     * @param {string} [challengeId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesGetInfoRaw(requestParameters: GetChallengesGetInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeInfoResponse>>;

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    getChallengesGetInfo(requestParameters: GetChallengesGetInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeInfoResponse>;

    /**
     * Gets challenge quests for a single Challenge.
     * @param {string} id 
     * @param {boolean} [onlyActive] If true, returns only active quests. If false or not provided, returns all quests.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesIdQuestsRaw(requestParameters: GetChallengesIdQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWReward>>>;

    /**
     * Gets challenge quests for a single Challenge.
     */
    getChallengesIdQuests(requestParameters: GetChallengesIdQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWReward>>;

    /**
     * Get list of challenges for report dropdown
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengesListResponse>>;

    /**
     * Get list of challenges for report dropdown
     */
    getChallengesList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengesListResponse>;

    /**
     * Returns the public progress fields (current/target/lastSyncAt, reward art + name, unlockedAt). `sharedUnlockCode` is double-gated — only present when BOTH `unlockedAt` is set AND the caller is authenticated. Anonymous callers can poll the progress + art for the gauge UI; only authenticated callers see the code after unlock.
     * @summary Read a challenge\'s community-goal state (optionally authenticated)
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugCommunityGoalRaw(requestParameters: GetChallengesSlugCommunityGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeCommunityGoalResponse>>;

    /**
     * Returns the public progress fields (current/target/lastSyncAt, reward art + name, unlockedAt). `sharedUnlockCode` is double-gated — only present when BOTH `unlockedAt` is set AND the caller is authenticated. Anonymous callers can poll the progress + art for the gauge UI; only authenticated callers see the code after unlock.
     * Read a challenge\'s community-goal state (optionally authenticated)
     */
    getChallengesSlugCommunityGoal(requestParameters: GetChallengesSlugCommunityGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeCommunityGoalResponse>;

    /**
     * Verified U.S. Finals qualifiers, ordered by live current-round score (no rank numbers). Each row carries the round they qualified in for the R1/R2/R3 badge.
     * @summary Get verified Finals qualifiers (Finalists tab)
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugFinalistsRaw(requestParameters: GetChallengesSlugFinalistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrFinalistsResponse>>;

    /**
     * Verified U.S. Finals qualifiers, ordered by live current-round score (no rank numbers). Each row carries the round they qualified in for the R1/R2/R3 badge.
     * Get verified Finals qualifiers (Finalists tab)
     */
    getChallengesSlugFinalists(requestParameters: GetChallengesSlugFinalistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrFinalistsResponse>;

    /**
     * Tells the login modal which fields it can hide for a returning member identified via a signed partner-platform handshake (Minelab Realm today; other partners later). No session, no email lookup. 
     * @param {string} slug Challenge slug (e.g. \&quot;minelab-rttr\&quot;).
     * @param {string} xRealmUUID Partner-issued user identifier. Header name is Realm-specific today; will generalize when a second partner platform integrates.
     * @param {string} xRealmTS 
     * @param {string} xRealmSig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugMemberStatusRaw(requestParameters: GetChallengesSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeMemberStatusResponse>>;

    /**
     * Tells the login modal which fields it can hide for a returning member identified via a signed partner-platform handshake (Minelab Realm today; other partners later). No session, no email lookup. 
     */
    getChallengesSlugMemberStatus(requestParameters: GetChallengesSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeMemberStatusResponse>;

    /**
     * Returns the user\'s per-objective progression plus isComplete and pointsTotal for the Challenge identified by slug. The Challenge\'s brandActivationId is the join key. When the user has no progression doc yet, a zero-state response is returned (200, empty progression and prerequisites, isComplete false, pointsTotal 0). 404 only when the slug is unknown.
     * @summary Read the calling user\'s ActivityProgression for this Challenge
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugMyProgressionRaw(requestParameters: GetChallengesSlugMyProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityProgression>>;

    /**
     * Returns the user\'s per-objective progression plus isComplete and pointsTotal for the Challenge identified by slug. The Challenge\'s brandActivationId is the join key. When the user has no progression doc yet, a zero-state response is returned (200, empty progression and prerequisites, isComplete false, pointsTotal 0). 404 only when the slug is unknown.
     * Read the calling user\'s ActivityProgression for this Challenge
     */
    getChallengesSlugMyProgression(requestParameters: GetChallengesSlugMyProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityProgression>;

    /**
     * Returns the authenticated user\'s rank and points for a challenge. Returns isParticipating=false if unauthenticated or not enrolled.
     * @summary Get my rank in a challenge
     * @param {string} slug 
     * @param {number} [segment] Segment index to scope rank to. Omit for overall rank.
     * @param {'global' | 'us-race'} [scope] Leaderboard scope. Must match the scope used by /standings — otherwise the pinned \&quot;My Rank\&quot; row would disagree with the visible list. \&quot;us-race\&quot; returns isParticipating&#x3D;false for users not in the eligible US pool (declaredCountry !&#x3D;&#x3D; \&quot;US\&quot; OR status !&#x3D;&#x3D; \&quot;eligible\&quot;) since they don\&#39;t appear on that leaderboard.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugMyRankRaw(requestParameters: GetChallengesSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeMyRankResponse>>;

    /**
     * Returns the authenticated user\'s rank and points for a challenge. Returns isParticipating=false if unauthenticated or not enrolled.
     * Get my rank in a challenge
     */
    getChallengesSlugMyRank(requestParameters: GetChallengesSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeMyRankResponse>;

    /**
     * Returns the Realm-provided country of residence for pre-filling the login modal\'s Country picker, identified via the signed Realm handshake. Split out of member-status so the (slow) Minelab UserDetails call never blocks the modal from opening. Country only — the Realm email is never exposed. 
     * @param {string} slug Challenge slug (e.g. \&quot;minelab-rttr\&quot;).
     * @param {string} xRealmUUID Realm user id from the signed handoff.
     * @param {string} xRealmTS 
     * @param {string} xRealmSig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugRealmCountryRaw(requestParameters: GetChallengesSlugRealmCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeRealmCountryResponse>>;

    /**
     * Returns the Realm-provided country of residence for pre-filling the login modal\'s Country picker, identified via the signed Realm handshake. Split out of member-status so the (slow) Minelab UserDetails call never blocks the modal from opening. Country only — the Realm email is never exposed. 
     */
    getChallengesSlugRealmCountry(requestParameters: GetChallengesSlugRealmCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeRealmCountryResponse>;

    /**
     * Returns a referral code unique to this challenge, creating one on first access. Format is driven by Challenge.referralCodePrefix — prefixed codes use a 5-digit numeric suffix, unprefixed challenges fall back to the platform short-uuid format.
     * @summary Get (or create) the authenticated user\'s challenge-scoped referral code
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugReferralsOwnCodeRaw(requestParameters: GetChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeSlugOwnReferralCodeResponse>>;

    /**
     * Returns a referral code unique to this challenge, creating one on first access. Format is driven by Challenge.referralCodePrefix — prefixed codes use a 5-digit numeric suffix, unprefixed challenges fall back to the platform short-uuid format.
     * Get (or create) the authenticated user\'s challenge-scoped referral code
     */
    getChallengesSlugReferralsOwnCode(requestParameters: GetChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeSlugOwnReferralCodeResponse>;

    /**
     * Returns X-of-X progress counters for all RTTR earning actions.
     * @summary Get authenticated user\'s RTTR earning state
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugRttrUserStateRaw(requestParameters: GetChallengesSlugRttrUserStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrUserStateResponse>>;

    /**
     * Returns X-of-X progress counters for all RTTR earning actions.
     * Get authenticated user\'s RTTR earning state
     */
    getChallengesSlugRttrUserState(requestParameters: GetChallengesSlugRttrUserStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrUserStateResponse>;

    /**
     * Resolves and returns the shared bulk partner unlock code configured on `segments[segmentIndex]`\'s first PrizePool → RewardConfig → PromoToken.couponCodes[0]. Only returned when the calling user has completed the segment\'s required objectives (ActivityProgression.isComplete === true). 403 with `UNLOCK_GATE_NOT_MET` when the gate is unmet; 404 if the segment or code is missing.
     * @summary Read a segment\'s bulk partner unlock code (gated)
     * @param {string} slug 
     * @param {string} segmentIndex 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugSegmentsSegmentIndexUnlockCodeRaw(requestParameters: GetChallengesSlugSegmentsSegmentIndexUnlockCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SegmentUnlockCodeResponse>>;

    /**
     * Resolves and returns the shared bulk partner unlock code configured on `segments[segmentIndex]`\'s first PrizePool → RewardConfig → PromoToken.couponCodes[0]. Only returned when the calling user has completed the segment\'s required objectives (ActivityProgression.isComplete === true). 403 with `UNLOCK_GATE_NOT_MET` when the gate is unmet; 404 if the segment or code is missing.
     * Read a segment\'s bulk partner unlock code (gated)
     */
    getChallengesSlugSegmentsSegmentIndexUnlockCode(requestParameters: GetChallengesSlugSegmentsSegmentIndexUnlockCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SegmentUnlockCodeResponse>;

    /**
     * Public brand-curated photo showcase for a challenge\'s hub carousel (≤20, ordered by showcaseRank).
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugShowcasePhotosRaw(requestParameters: GetChallengesSlugShowcasePhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeShowcasePhotosResponse>>;

    /**
     * Public brand-curated photo showcase for a challenge\'s hub carousel (≤20, ordered by showcaseRank).
     */
    getChallengesSlugShowcasePhotos(requestParameters: GetChallengesSlugShowcasePhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeShowcasePhotosResponse>;

    /**
     * Returns ranked standings for a challenge. Omit segment for overall (all segments summed); pass segment=N for a specific round.
     * @summary Get challenge standings
     * @param {string} slug 
     * @param {number} [segment] Segment index to filter standings by. Omit for overall standings across all segments.
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {'global' | 'us-race'} [scope] Leaderboard scope. \&quot;global\&quot; (default) returns every member regardless of country/eligibility — eligible US users appear here too. \&quot;us-race\&quot; returns only Finals-qualification-eligible US members (declaredCountry &#x3D;&#x3D;&#x3D; \&quot;US\&quot; AND status &#x3D;&#x3D;&#x3D; \&quot;eligible\&quot;). Challenges without eligibilityGeo configured can pass either; the filter is a no-op when no membership has declaredCountry set.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSlugStandingsRaw(requestParameters: GetChallengesSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrStandingsResponse>>;

    /**
     * Returns ranked standings for a challenge. Omit segment for overall (all segments summed); pass segment=N for a specific round.
     * Get challenge standings
     */
    getChallengesSlugStandings(requestParameters: GetChallengesSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrStandingsResponse>;

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     * @param {string} id 
     * @param {Array<string>} [userIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    getChallengesSummaryIdRaw(requestParameters: GetChallengesSummaryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeSummaryResponse>>;

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    getChallengesSummaryId(requestParameters: GetChallengesSummaryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeSummaryResponse>;

    /**
     * Manually remove and replace a winner from a draw log.
     * @param {string} id 
     * @param {RedrawChallengePrizeBody} [redrawChallengePrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    updateChallengesDrawLogIdRedrawRaw(requestParameters: UpdateChallengesDrawLogIdRedrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Manually remove and replace a winner from a draw log.
     */
    updateChallengesDrawLogIdRedraw(requestParameters: UpdateChallengesDrawLogIdRedrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Create or update a Challenge
     * @param {string} id 
     * @param {ChallengeBody} [challengeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    updateChallengesIdRaw(requestParameters: UpdateChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>>;

    /**
     * Create or update a Challenge
     */
    updateChallengesId(requestParameters: UpdateChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge>;

    /**
     * Update a user\'s challenge membership
     * @param {string} id 
     * @param {UpdateUserChallengeMembershipBody} [updateUserChallengeMembershipBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    updateChallengesIdMembershipRaw(requestParameters: UpdateChallengesIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update a user\'s challenge membership
     */
    updateChallengesIdMembership(requestParameters: UpdateChallengesIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Updates a challenge prize
     * @param {string} id 
     * @param {ChallengePrizeBody} [challengePrizeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    updateChallengesPrizesIdRaw(requestParameters: UpdateChallengesPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizePool>>;

    /**
     * Updates a challenge prize
     */
    updateChallengesPrizesId(requestParameters: UpdateChallengesPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizePool>;

    /**
     * Confirm that the user has been notified of a prize win
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ChallengesApiInterface
     */
    updateConfirmNotifyPrizeWonIdRaw(requestParameters: UpdateConfirmNotifyPrizeWonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Confirm that the user has been notified of a prize win
     */
    updateConfirmNotifyPrizeWonId(requestParameters: UpdateConfirmNotifyPrizeWonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class ChallengesApi extends runtime.BaseAPI implements ChallengesApiInterface {

    /**
     * Create a new Challenge
     */
    async createChallengesRaw(requestParameters: CreateChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengeBodyToJSON(requestParameters['challengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeFromJSON(jsonValue));
    }

    /**
     * Create a new Challenge
     */
    async createChallenges(requestParameters: CreateChallengesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge> {
        const response = await this.createChallengesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually distribute a challenge prize
     */
    async createChallengesDistributeIdRaw(requestParameters: CreateChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesDistributeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/distribute/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TriggerChallengeDistributionBodyToJSON(requestParameters['triggerChallengeDistributionBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Manually distribute a challenge prize
     */
    async createChallengesDistributeId(requestParameters: CreateChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createChallengesDistributeIdRaw(requestParameters, initOverrides);
    }

    /**
     * Manually distribute prizes based on specified draw log
     */
    async createChallengesDistributeIdDrawLogRaw(requestParameters: CreateChallengesDistributeIdDrawLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesDistributeIdDrawLog().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/distribute/{id}/draw-log`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Manually distribute prizes based on specified draw log
     */
    async createChallengesDistributeIdDrawLog(requestParameters: CreateChallengesDistributeIdDrawLogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createChallengesDistributeIdDrawLogRaw(requestParameters, initOverrides);
    }

    /**
     * Distribute the prize for a single winner on a CHALLENGE_DRAW log. Per-winner alternative to the bulk distribute endpoint so admins can verify + ship one winner at a time.
     */
    async createChallengesDrawLogIdDistributeWinnerRaw(requestParameters: CreateChallengesDrawLogIdDistributeWinnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DistributeWinnerResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesDrawLogIdDistributeWinner().'
            );
        }

        if (requestParameters['distributeWinnerBody'] == null) {
            throw new runtime.RequiredError(
                'distributeWinnerBody',
                'Required parameter "distributeWinnerBody" was null or undefined when calling createChallengesDrawLogIdDistributeWinner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/draw-log/{id}/distribute-winner`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DistributeWinnerBodyToJSON(requestParameters['distributeWinnerBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DistributeWinnerResponseFromJSON(jsonValue));
    }

    /**
     * Distribute the prize for a single winner on a CHALLENGE_DRAW log. Per-winner alternative to the bulk distribute endpoint so admins can verify + ship one winner at a time.
     */
    async createChallengesDrawLogIdDistributeWinner(requestParameters: CreateChallengesDrawLogIdDistributeWinnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DistributeWinnerResponse> {
        const response = await this.createChallengesDrawLogIdDistributeWinnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new challenge membership for a user when they accept a challenge
     */
    async createChallengesIdAcceptRaw(requestParameters: CreateChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesIdAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a new challenge membership for a user when they accept a challenge
     */
    async createChallengesIdAccept(requestParameters: CreateChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createChallengesIdAcceptRaw(requestParameters, initOverrides);
    }

    /**
     * Duplicate an existing challenge with fresh prize pools
     */
    async createChallengesIdDuplicateRaw(requestParameters: CreateChallengesIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesIdDuplicate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/duplicate`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeFromJSON(jsonValue));
    }

    /**
     * Duplicate an existing challenge with fresh prize pools
     */
    async createChallengesIdDuplicate(requestParameters: CreateChallengesIdDuplicateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge> {
        const response = await this.createChallengesIdDuplicateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually trigger the Grand Prize drawing for a challenge
     */
    async createChallengesIdGrandPrizeDrawRaw(requestParameters: CreateChallengesIdGrandPrizeDrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesIdGrandPrizeDraw().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/grand-prize/draw`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeFromJSON(jsonValue));
    }

    /**
     * Manually trigger the Grand Prize drawing for a challenge
     */
    async createChallengesIdGrandPrizeDraw(requestParameters: CreateChallengesIdGrandPrizeDrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge> {
        const response = await this.createChallengesIdGrandPrizeDrawRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit user response to challenge-specific questions (newsletter opt-in, etc.)
     */
    async createChallengesIdResponseRaw(requestParameters: CreateChallengesIdResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SubmitChallengeResponseResult>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createChallengesIdResponse().'
            );
        }

        if (requestParameters['submitChallengeResponseBody'] == null) {
            throw new runtime.RequiredError(
                'submitChallengeResponseBody',
                'Required parameter "submitChallengeResponseBody" was null or undefined when calling createChallengesIdResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/response`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubmitChallengeResponseBodyToJSON(requestParameters['submitChallengeResponseBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SubmitChallengeResponseResultFromJSON(jsonValue));
    }

    /**
     * Submit user response to challenge-specific questions (newsletter opt-in, etc.)
     */
    async createChallengesIdResponse(requestParameters: CreateChallengesIdResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SubmitChallengeResponseResult> {
        const response = await this.createChallengesIdResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new Challenge prize
     */
    async createChallengesPrizesRaw(requestParameters: CreateChallengesPrizesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizePool>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/prizes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengePrizeBodyToJSON(requestParameters['challengePrizeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrizePoolFromJSON(jsonValue));
    }

    /**
     * Create a new Challenge prize
     */
    async createChallengesPrizes(requestParameters: CreateChallengesPrizesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizePool> {
        const response = await this.createChallengesPrizesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fills in attestation + geo fields on an existing ChallengeMembership for a user with myMembershipNeedsCompletion=true. Setters-only — never overwrites existing values.
     */
    async createChallengesSlugCompleteProfileRaw(requestParameters: CreateChallengesSlugCompleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteChallengeProfileResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugCompleteProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/complete-profile`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteChallengeProfileBodyToJSON(requestParameters['completeChallengeProfileBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteChallengeProfileResponseFromJSON(jsonValue));
    }

    /**
     * Fills in attestation + geo fields on an existing ChallengeMembership for a user with myMembershipNeedsCompletion=true. Setters-only — never overwrites existing values.
     */
    async createChallengesSlugCompleteProfile(requestParameters: CreateChallengesSlugCompleteProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteChallengeProfileResponse> {
        const response = await this.createChallengesSlugCompleteProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Flips ChallengeMembership.onboardingComplete to true for the authenticated user + the challenge with the given slug. Idempotent. Called on Submit OR Skip from branded onboarding modals. Gates the per-login auto-pop of the onboarding modal — once true, hub mounts directly without surfacing the modal again. Profile-edit drawer remains the always-on access path for avatar/nickname changes. 
     * Mark the authenticated user\'s challenge-scoped onboarding flow as complete
     */
    async createChallengesSlugOnboardingCompleteRaw(requestParameters: CreateChallengesSlugOnboardingCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugOnboardingComplete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/onboarding-complete`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Flips ChallengeMembership.onboardingComplete to true for the authenticated user + the challenge with the given slug. Idempotent. Called on Submit OR Skip from branded onboarding modals. Gates the per-login auto-pop of the onboarding modal — once true, hub mounts directly without surfacing the modal again. Profile-edit drawer remains the always-on access path for avatar/nickname changes. 
     * Mark the authenticated user\'s challenge-scoped onboarding flow as complete
     */
    async createChallengesSlugOnboardingComplete(requestParameters: CreateChallengesSlugOnboardingCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createChallengesSlugOnboardingCompleteRaw(requestParameters, initOverrides);
    }

    /**
     * Authenticates a Realm user via the signed X-Realm handshake without an email verification code, pulling the verified email from the Minelab Users Core Service to find-or-create the DevourPlay account. Returns 422 when Realm has no email on file so the client can fall back to email + code. The caller should follow up with POST /challenges/{slug}/register (authenticated) to record terms + declared geo and bind the realmUuid.
     * Codeless Realm sign-in (mints a session from a verified embed)
     */
    async createChallengesSlugRealmSigninRaw(requestParameters: CreateChallengesSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Token>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmUUID'] == null) {
            throw new runtime.RequiredError(
                'xRealmUUID',
                'Required parameter "xRealmUUID" was null or undefined when calling createChallengesSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmTS'] == null) {
            throw new runtime.RequiredError(
                'xRealmTS',
                'Required parameter "xRealmTS" was null or undefined when calling createChallengesSlugRealmSignin().'
            );
        }

        if (requestParameters['xRealmSig'] == null) {
            throw new runtime.RequiredError(
                'xRealmSig',
                'Required parameter "xRealmSig" was null or undefined when calling createChallengesSlugRealmSignin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }


        let urlPath = `/challenges/{slug}/realm-signin`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RealmSigninBodyToJSON(requestParameters['realmSigninBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TokenFromJSON(jsonValue));
    }

    /**
     * Authenticates a Realm user via the signed X-Realm handshake without an email verification code, pulling the verified email from the Minelab Users Core Service to find-or-create the DevourPlay account. Returns 422 when Realm has no email on file so the client can fall back to email + code. The caller should follow up with POST /challenges/{slug}/register (authenticated) to record terms + declared geo and bind the realmUuid.
     * Codeless Realm sign-in (mints a session from a verified embed)
     */
    async createChallengesSlugRealmSignin(requestParameters: CreateChallengesSlugRealmSigninRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Token> {
        const response = await this.createChallengesSlugRealmSigninRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the authenticated user\'s challenge-scoped referral code. Pass a custom string in the body to claim a vanity code (uniqueness checked server-side, 409 on collision). Pass an empty body to regenerate the auto-gen code — useful when the challenge\'s referralCodePrefix has changed and the user wants the new branded format. 
     * Claim a custom challenge-scoped referral code or regenerate an auto-gen code
     */
    async createChallengesSlugReferralsOwnCodeRaw(requestParameters: CreateChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PostChallengeSlugReferralsOwnCodeResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugReferralsOwnCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/referrals/own-code`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PostChallengeSlugReferralsOwnCodeRequestToJSON(requestParameters['postChallengeSlugReferralsOwnCodeRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PostChallengeSlugReferralsOwnCodeResponseFromJSON(jsonValue));
    }

    /**
     * Sets the authenticated user\'s challenge-scoped referral code. Pass a custom string in the body to claim a vanity code (uniqueness checked server-side, 409 on collision). Pass an empty body to regenerate the auto-gen code — useful when the challenge\'s referralCodePrefix has changed and the user wants the new branded format. 
     * Claim a custom challenge-scoped referral code or regenerate an auto-gen code
     */
    async createChallengesSlugReferralsOwnCode(requestParameters: CreateChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PostChallengeSlugReferralsOwnCodeResponse> {
        const response = await this.createChallengesSlugReferralsOwnCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Records the user\'s acceptance of terms and any per-challenge eligibility checkboxes, and links a Realm UUID to the User if X-Realm-UUID header is present. Required for earning points on challenges that have eligibilityCheckboxes configured.
     * Complete challenge registration with eligibility attestations
     */
    async createChallengesSlugRegisterRaw(requestParameters: CreateChallengesSlugRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeRegisterResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRegister().'
            );
        }

        if (requestParameters['challengeRegisterRequest'] == null) {
            throw new runtime.RequiredError(
                'challengeRegisterRequest',
                'Required parameter "challengeRegisterRequest" was null or undefined when calling createChallengesSlugRegister().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/register`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengeRegisterRequestToJSON(requestParameters['challengeRegisterRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeRegisterResponseFromJSON(jsonValue));
    }

    /**
     * Records the user\'s acceptance of terms and any per-challenge eligibility checkboxes, and links a Realm UUID to the User if X-Realm-UUID header is present. Required for earning points on challenges that have eligibilityCheckboxes configured.
     * Complete challenge registration with eligibility attestations
     */
    async createChallengesSlugRegister(requestParameters: CreateChallengesSlugRegisterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeRegisterResponse> {
        const response = await this.createChallengesSlugRegisterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Honor-system claim — one per user per round. Platform and points are determined by the active segment.
     * Claim points for following the active round\'s Minelab social channel
     */
    async createChallengesSlugRttrClaimSocialFollowRaw(requestParameters: CreateChallengesSlugRttrClaimSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrClaimSocialFollowResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrClaimSocialFollow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-claim-social-follow`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrClaimSocialFollowRequestToJSON(requestParameters['rttrClaimSocialFollowRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrClaimSocialFollowResponseFromJSON(jsonValue));
    }

    /**
     * Honor-system claim — one per user per round. Platform and points are determined by the active segment.
     * Claim points for following the active round\'s Minelab social channel
     */
    async createChallengesSlugRttrClaimSocialFollow(requestParameters: CreateChallengesSlugRttrClaimSocialFollowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrClaimSocialFollowResponse> {
        const response = await this.createChallengesSlugRttrClaimSocialFollowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Honor-system claim — one per user per post per round. Active platform is determined server-side from the segment index. Idempotent via the unique compound index — repeat calls with the same normalized postUrl return 409.
     * Claim points for liking a specific Minelab social post during the active round
     */
    async createChallengesSlugRttrClaimSocialLikeRaw(requestParameters: CreateChallengesSlugRttrClaimSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrClaimSocialLikeResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrClaimSocialLike().'
            );
        }

        if (requestParameters['rttrClaimSocialLikeBody'] == null) {
            throw new runtime.RequiredError(
                'rttrClaimSocialLikeBody',
                'Required parameter "rttrClaimSocialLikeBody" was null or undefined when calling createChallengesSlugRttrClaimSocialLike().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-claim-social-like`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrClaimSocialLikeBodyToJSON(requestParameters['rttrClaimSocialLikeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrClaimSocialLikeResponseFromJSON(jsonValue));
    }

    /**
     * Honor-system claim — one per user per post per round. Active platform is determined server-side from the segment index. Idempotent via the unique compound index — repeat calls with the same normalized postUrl return 409.
     * Claim points for liking a specific Minelab social post during the active round
     */
    async createChallengesSlugRttrClaimSocialLike(requestParameters: CreateChallengesSlugRttrClaimSocialLikeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrClaimSocialLikeResponse> {
        const response = await this.createChallengesSlugRttrClaimSocialLikeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sends the Grow the Realm invite email and credits the inviter on a confirmed send. Cap of 3 rewarded referrals per round, shared with code-signup referrals.
     * Email a friend an invitation to join Race to the Realm
     */
    async createChallengesSlugRttrInviteRaw(requestParameters: CreateChallengesSlugRttrInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrInviteResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrInvite().'
            );
        }

        if (requestParameters['rttrInviteBody'] == null) {
            throw new runtime.RequiredError(
                'rttrInviteBody',
                'Required parameter "rttrInviteBody" was null or undefined when calling createChallengesSlugRttrInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-invite`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrInviteBodyToJSON(requestParameters['rttrInviteBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrInviteResponseFromJSON(jsonValue));
    }

    /**
     * Sends the Grow the Realm invite email and credits the inviter on a confirmed send. Cap of 3 rewarded referrals per round, shared with code-signup referrals.
     * Email a friend an invitation to join Race to the Realm
     */
    async createChallengesSlugRttrInvite(requestParameters: CreateChallengesSlugRttrInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrInviteResponse> {
        const response = await this.createChallengesSlugRttrInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Awards RTTR points for the active round. Max 3 posts per round. TikTok posts are verified by Apify scraper (handles /video/ and /photo/ canonical URLs, resolves /t/ share short links via redirect-follow). Instagram posts are verified via Browserless (loads the public post page and reads the caption from og:description, since Apify\'s IG scraper is blocked at our egress). Facebook posts are verified by Apify scraper. 
     * Submit an
     */
    async createChallengesSlugRttrPostSubmitRaw(requestParameters: CreateChallengesSlugRttrPostSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrPostSubmitResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrPostSubmit().'
            );
        }

        if (requestParameters['rttrPostSubmitRequest'] == null) {
            throw new runtime.RequiredError(
                'rttrPostSubmitRequest',
                'Required parameter "rttrPostSubmitRequest" was null or undefined when calling createChallengesSlugRttrPostSubmit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-post-submit`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrPostSubmitRequestToJSON(requestParameters['rttrPostSubmitRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrPostSubmitResponseFromJSON(jsonValue));
    }

    /**
     * Awards RTTR points for the active round. Max 3 posts per round. TikTok posts are verified by Apify scraper (handles /video/ and /photo/ canonical URLs, resolves /t/ share short links via redirect-follow). Instagram posts are verified via Browserless (loads the public post page and reads the caption from og:description, since Apify\'s IG scraper is blocked at our egress). Facebook posts are verified by Apify scraper. 
     * Submit an
     */
    async createChallengesSlugRttrPostSubmit(requestParameters: CreateChallengesSlugRttrPostSubmitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrPostSubmitResponse> {
        const response = await this.createChallengesSlugRttrPostSubmitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Awards points for attending an RTTR event. One redemption per user per round per eventType — MineLab and Club tracks are independent.
     * Redeem an RTTR event QR code
     */
    async createChallengesSlugRttrQrRedeemRaw(requestParameters: CreateChallengesSlugRttrQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrQrRedeemResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrQrRedeem().'
            );
        }

        if (requestParameters['rttrQrRedeemRequest'] == null) {
            throw new runtime.RequiredError(
                'rttrQrRedeemRequest',
                'Required parameter "rttrQrRedeemRequest" was null or undefined when calling createChallengesSlugRttrQrRedeem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-qr-redeem`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrQrRedeemRequestToJSON(requestParameters['rttrQrRedeemRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrQrRedeemResponseFromJSON(jsonValue));
    }

    /**
     * Awards points for attending an RTTR event. One redemption per user per round per eventType — MineLab and Club tracks are independent.
     * Redeem an RTTR event QR code
     */
    async createChallengesSlugRttrQrRedeem(requestParameters: CreateChallengesSlugRttrQrRedeemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrQrRedeemResponse> {
        const response = await this.createChallengesSlugRttrQrRedeemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Looks up the serial in Minelab\'s HubSpot Product Registrations object, resolves the product to a tier, and awards points (capped per user). New purchases earn tier-based points up to 16k total; existing registrations earn 3k each up to 3 claims / 9k total.
     * Verify a Minelab product serial and award RTTR points
     */
    async createChallengesSlugRttrSerialVerifyRaw(requestParameters: CreateChallengesSlugRttrSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrSerialVerifyResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling createChallengesSlugRttrSerialVerify().'
            );
        }

        if (requestParameters['rttrSerialVerifyRequest'] == null) {
            throw new runtime.RequiredError(
                'rttrSerialVerifyRequest',
                'Required parameter "rttrSerialVerifyRequest" was null or undefined when calling createChallengesSlugRttrSerialVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-serial-verify`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RttrSerialVerifyRequestToJSON(requestParameters['rttrSerialVerifyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrSerialVerifyResponseFromJSON(jsonValue));
    }

    /**
     * Looks up the serial in Minelab\'s HubSpot Product Registrations object, resolves the product to a tier, and awards points (capped per user). New purchases earn tier-based points up to 16k total; existing registrations earn 3k each up to 3 claims / 9k total.
     * Verify a Minelab product serial and award RTTR points
     */
    async createChallengesSlugRttrSerialVerify(requestParameters: CreateChallengesSlugRttrSerialVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrSerialVerifyResponse> {
        const response = await this.createChallengesSlugRttrSerialVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually reset a challenge prize as if it never distributed yet.
     */
    async deleteChallengesDistributeIdRaw(requestParameters: DeleteChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteChallengesDistributeId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/distribute/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: ResetChallengePrizeBodyToJSON(requestParameters['resetChallengePrizeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Manually reset a challenge prize as if it never distributed yet.
     */
    async deleteChallengesDistributeId(requestParameters: DeleteChallengesDistributeIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteChallengesDistributeIdRaw(requestParameters, initOverrides);
    }

    /**
     * Manually delete a dry run draw log.
     */
    async deleteChallengesDrawLogIdRaw(requestParameters: DeleteChallengesDrawLogIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteChallengesDrawLogId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/draw-log/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Manually delete a dry run draw log.
     */
    async deleteChallengesDrawLogId(requestParameters: DeleteChallengesDrawLogIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteChallengesDrawLogIdRaw(requestParameters, initOverrides);
    }

    /**
     * Remove a specific challenge and any associated challengeMemberships
     */
    async deleteChallengesIdRaw(requestParameters: DeleteChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteChallengesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Remove a specific challenge and any associated challengeMemberships
     */
    async deleteChallengesId(requestParameters: DeleteChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteChallengesIdRaw(requestParameters, initOverrides);
    }

    /**
     * Delete all users progress for all quests for a specific challenge.
     */
    async deleteChallengesProgressIdRaw(requestParameters: DeleteChallengesProgressIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteChallengesProgressId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/progress/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete all users progress for all quests for a specific challenge.
     */
    async deleteChallengesProgressId(requestParameters: DeleteChallengesProgressIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteChallengesProgressIdRaw(requestParameters, initOverrides);
    }

    /**
     * Get aggregated dashboard stats for a challenge including segment and milestone completion rates
     */
    async getChallengeDashboardIdRaw(requestParameters: GetChallengeDashboardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeDashboardResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getChallengeDashboardId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge-dashboard/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeDashboardResponseFromJSON(jsonValue));
    }

    /**
     * Get aggregated dashboard stats for a challenge including segment and milestone completion rates
     */
    async getChallengeDashboardId(requestParameters: GetChallengeDashboardIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeDashboardResponse> {
        const response = await this.getChallengeDashboardIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get audit logs for challenge prize drawings
     */
    async getChallengeDrawLogsRaw(requestParameters: GetChallengeDrawLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDrawLogsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['challengeId'] != null) {
            queryParameters['challengeId'] = requestParameters['challengeId'];
        }

        if (requestParameters['drawType'] != null) {
            queryParameters['drawType'] = requestParameters['drawType'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge-draw-logs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDrawLogsResponseFromJSON(jsonValue));
    }

    /**
     * Get audit logs for challenge prize drawings
     */
    async getChallengeDrawLogs(requestParameters: GetChallengeDrawLogsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDrawLogsResponse> {
        const response = await this.getChallengeDrawLogsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Export a single draw log as JSON for audit purposes
     */
    async getChallengeDrawLogsIdExportRaw(requestParameters: GetChallengeDrawLogsIdExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getChallengeDrawLogsIdExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge-draw-logs/{id}/export`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Export a single draw log as JSON for audit purposes
     */
    async getChallengeDrawLogsIdExport(requestParameters: GetChallengeDrawLogsIdExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.getChallengeDrawLogsIdExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch all challenge prizes won by the user
     */
    async getChallengePrizesWonRaw(requestParameters: GetChallengePrizesWonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PrizePool>>> {
        const queryParameters: any = {};

        if (requestParameters['newPrizesOnly'] != null) {
            queryParameters['newPrizesOnly'] = requestParameters['newPrizesOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge-prizes-won`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PrizePoolFromJSON));
    }

    /**
     * Fetch all challenge prizes won by the user
     */
    async getChallengePrizesWon(requestParameters: GetChallengePrizesWonRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PrizePool>> {
        const response = await this.getChallengePrizesWonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get detailed user report for a challenge including entries and prizes
     */
    async getChallengeUserReportRaw(requestParameters: GetChallengeUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['challengeId'] == null) {
            throw new runtime.RequiredError(
                'challengeId',
                'Required parameter "challengeId" was null or undefined when calling getChallengeUserReport().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['challengeId'] != null) {
            queryParameters['challengeId'] = requestParameters['challengeId'];
        }

        if (requestParameters['format'] != null) {
            queryParameters['format'] = requestParameters['format'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenge-user-report`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Get detailed user report for a challenge including entries and prizes
     */
    async getChallengeUserReport(requestParameters: GetChallengeUserReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getChallengeUserReportRaw(requestParameters, initOverrides);
    }

    /**
     * Get list of all challenges with user acceptance status
     */
    async getChallengesRaw(requestParameters: GetChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengesResponse>> {
        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['unassignedOnly'] != null) {
            queryParameters['unassignedOnly'] = requestParameters['unassignedOnly'];
        }

        if (requestParameters['allowNonActives'] != null) {
            queryParameters['allowNonActives'] = requestParameters['allowNonActives'];
        }

        if (requestParameters['brandMap'] != null) {
            queryParameters['brandMap'] = requestParameters['brandMap'];
        }

        if (requestParameters['includeExpired'] != null) {
            queryParameters['includeExpired'] = requestParameters['includeExpired'];
        }

        if (requestParameters['brandId'] != null) {
            queryParameters['brandId'] = requestParameters['brandId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengesResponseFromJSON(jsonValue));
    }

    /**
     * Get list of all challenges with user acceptance status
     */
    async getChallenges(requestParameters: GetChallengesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengesResponse> {
        const response = await this.getChallengesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    async getChallengesGetInfoRaw(requestParameters: GetChallengesGetInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeInfoResponse>> {
        const queryParameters: any = {};

        if (requestParameters['slug'] != null) {
            queryParameters['slug'] = requestParameters['slug'];
        }

        if (requestParameters['challengeId'] != null) {
            queryParameters['challengeId'] = requestParameters['challengeId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/get-info`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeInfoResponseFromJSON(jsonValue));
    }

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    async getChallengesGetInfo(requestParameters: GetChallengesGetInfoRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeInfoResponse> {
        const response = await this.getChallengesGetInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets challenge quests for a single Challenge.
     */
    async getChallengesIdQuestsRaw(requestParameters: GetChallengesIdQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OWReward>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getChallengesIdQuests().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['onlyActive'] != null) {
            queryParameters['onlyActive'] = requestParameters['onlyActive'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/quests`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OWRewardFromJSON));
    }

    /**
     * Gets challenge quests for a single Challenge.
     */
    async getChallengesIdQuests(requestParameters: GetChallengesIdQuestsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OWReward>> {
        const response = await this.getChallengesIdQuestsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of challenges for report dropdown
     */
    async getChallengesListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengesListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges-list`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengesListResponseFromJSON(jsonValue));
    }

    /**
     * Get list of challenges for report dropdown
     */
    async getChallengesList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengesListResponse> {
        const response = await this.getChallengesListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the public progress fields (current/target/lastSyncAt, reward art + name, unlockedAt). `sharedUnlockCode` is double-gated — only present when BOTH `unlockedAt` is set AND the caller is authenticated. Anonymous callers can poll the progress + art for the gauge UI; only authenticated callers see the code after unlock.
     * Read a challenge\'s community-goal state (optionally authenticated)
     */
    async getChallengesSlugCommunityGoalRaw(requestParameters: GetChallengesSlugCommunityGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeCommunityGoalResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugCommunityGoal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/community-goal`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeCommunityGoalResponseFromJSON(jsonValue));
    }

    /**
     * Returns the public progress fields (current/target/lastSyncAt, reward art + name, unlockedAt). `sharedUnlockCode` is double-gated — only present when BOTH `unlockedAt` is set AND the caller is authenticated. Anonymous callers can poll the progress + art for the gauge UI; only authenticated callers see the code after unlock.
     * Read a challenge\'s community-goal state (optionally authenticated)
     */
    async getChallengesSlugCommunityGoal(requestParameters: GetChallengesSlugCommunityGoalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeCommunityGoalResponse> {
        const response = await this.getChallengesSlugCommunityGoalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Verified U.S. Finals qualifiers, ordered by live current-round score (no rank numbers). Each row carries the round they qualified in for the R1/R2/R3 badge.
     * Get verified Finals qualifiers (Finalists tab)
     */
    async getChallengesSlugFinalistsRaw(requestParameters: GetChallengesSlugFinalistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrFinalistsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugFinalists().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/challenges/{slug}/finalists`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrFinalistsResponseFromJSON(jsonValue));
    }

    /**
     * Verified U.S. Finals qualifiers, ordered by live current-round score (no rank numbers). Each row carries the round they qualified in for the R1/R2/R3 badge.
     * Get verified Finals qualifiers (Finalists tab)
     */
    async getChallengesSlugFinalists(requestParameters: GetChallengesSlugFinalistsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrFinalistsResponse> {
        const response = await this.getChallengesSlugFinalistsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tells the login modal which fields it can hide for a returning member identified via a signed partner-platform handshake (Minelab Realm today; other partners later). No session, no email lookup. 
     */
    async getChallengesSlugMemberStatusRaw(requestParameters: GetChallengesSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeMemberStatusResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugMemberStatus().'
            );
        }

        if (requestParameters['xRealmUUID'] == null) {
            throw new runtime.RequiredError(
                'xRealmUUID',
                'Required parameter "xRealmUUID" was null or undefined when calling getChallengesSlugMemberStatus().'
            );
        }

        if (requestParameters['xRealmTS'] == null) {
            throw new runtime.RequiredError(
                'xRealmTS',
                'Required parameter "xRealmTS" was null or undefined when calling getChallengesSlugMemberStatus().'
            );
        }

        if (requestParameters['xRealmSig'] == null) {
            throw new runtime.RequiredError(
                'xRealmSig',
                'Required parameter "xRealmSig" was null or undefined when calling getChallengesSlugMemberStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }


        let urlPath = `/challenges/{slug}/member-status`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeMemberStatusResponseFromJSON(jsonValue));
    }

    /**
     * Tells the login modal which fields it can hide for a returning member identified via a signed partner-platform handshake (Minelab Realm today; other partners later). No session, no email lookup. 
     */
    async getChallengesSlugMemberStatus(requestParameters: GetChallengesSlugMemberStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeMemberStatusResponse> {
        const response = await this.getChallengesSlugMemberStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the user\'s per-objective progression plus isComplete and pointsTotal for the Challenge identified by slug. The Challenge\'s brandActivationId is the join key. When the user has no progression doc yet, a zero-state response is returned (200, empty progression and prerequisites, isComplete false, pointsTotal 0). 404 only when the slug is unknown.
     * Read the calling user\'s ActivityProgression for this Challenge
     */
    async getChallengesSlugMyProgressionRaw(requestParameters: GetChallengesSlugMyProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ActivityProgression>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugMyProgression().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/my-progression`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ActivityProgressionFromJSON(jsonValue));
    }

    /**
     * Returns the user\'s per-objective progression plus isComplete and pointsTotal for the Challenge identified by slug. The Challenge\'s brandActivationId is the join key. When the user has no progression doc yet, a zero-state response is returned (200, empty progression and prerequisites, isComplete false, pointsTotal 0). 404 only when the slug is unknown.
     * Read the calling user\'s ActivityProgression for this Challenge
     */
    async getChallengesSlugMyProgression(requestParameters: GetChallengesSlugMyProgressionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ActivityProgression> {
        const response = await this.getChallengesSlugMyProgressionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the authenticated user\'s rank and points for a challenge. Returns isParticipating=false if unauthenticated or not enrolled.
     * Get my rank in a challenge
     */
    async getChallengesSlugMyRankRaw(requestParameters: GetChallengesSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeMyRankResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugMyRank().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['segment'] != null) {
            queryParameters['segment'] = requestParameters['segment'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/my-rank`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeMyRankResponseFromJSON(jsonValue));
    }

    /**
     * Returns the authenticated user\'s rank and points for a challenge. Returns isParticipating=false if unauthenticated or not enrolled.
     * Get my rank in a challenge
     */
    async getChallengesSlugMyRank(requestParameters: GetChallengesSlugMyRankRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeMyRankResponse> {
        const response = await this.getChallengesSlugMyRankRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the Realm-provided country of residence for pre-filling the login modal\'s Country picker, identified via the signed Realm handshake. Split out of member-status so the (slow) Minelab UserDetails call never blocks the modal from opening. Country only — the Realm email is never exposed. 
     */
    async getChallengesSlugRealmCountryRaw(requestParameters: GetChallengesSlugRealmCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeRealmCountryResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugRealmCountry().'
            );
        }

        if (requestParameters['xRealmUUID'] == null) {
            throw new runtime.RequiredError(
                'xRealmUUID',
                'Required parameter "xRealmUUID" was null or undefined when calling getChallengesSlugRealmCountry().'
            );
        }

        if (requestParameters['xRealmTS'] == null) {
            throw new runtime.RequiredError(
                'xRealmTS',
                'Required parameter "xRealmTS" was null or undefined when calling getChallengesSlugRealmCountry().'
            );
        }

        if (requestParameters['xRealmSig'] == null) {
            throw new runtime.RequiredError(
                'xRealmSig',
                'Required parameter "xRealmSig" was null or undefined when calling getChallengesSlugRealmCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRealmUUID'] != null) {
            headerParameters['X-Realm-UUID'] = String(requestParameters['xRealmUUID']);
        }

        if (requestParameters['xRealmTS'] != null) {
            headerParameters['X-Realm-TS'] = String(requestParameters['xRealmTS']);
        }

        if (requestParameters['xRealmSig'] != null) {
            headerParameters['X-Realm-Sig'] = String(requestParameters['xRealmSig']);
        }


        let urlPath = `/challenges/{slug}/realm-country`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeRealmCountryResponseFromJSON(jsonValue));
    }

    /**
     * Returns the Realm-provided country of residence for pre-filling the login modal\'s Country picker, identified via the signed Realm handshake. Split out of member-status so the (slow) Minelab UserDetails call never blocks the modal from opening. Country only — the Realm email is never exposed. 
     */
    async getChallengesSlugRealmCountry(requestParameters: GetChallengesSlugRealmCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeRealmCountryResponse> {
        const response = await this.getChallengesSlugRealmCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a referral code unique to this challenge, creating one on first access. Format is driven by Challenge.referralCodePrefix — prefixed codes use a 5-digit numeric suffix, unprefixed challenges fall back to the platform short-uuid format.
     * Get (or create) the authenticated user\'s challenge-scoped referral code
     */
    async getChallengesSlugReferralsOwnCodeRaw(requestParameters: GetChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetChallengeSlugOwnReferralCodeResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugReferralsOwnCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/referrals/own-code`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetChallengeSlugOwnReferralCodeResponseFromJSON(jsonValue));
    }

    /**
     * Returns a referral code unique to this challenge, creating one on first access. Format is driven by Challenge.referralCodePrefix — prefixed codes use a 5-digit numeric suffix, unprefixed challenges fall back to the platform short-uuid format.
     * Get (or create) the authenticated user\'s challenge-scoped referral code
     */
    async getChallengesSlugReferralsOwnCode(requestParameters: GetChallengesSlugReferralsOwnCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetChallengeSlugOwnReferralCodeResponse> {
        const response = await this.getChallengesSlugReferralsOwnCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns X-of-X progress counters for all RTTR earning actions.
     * Get authenticated user\'s RTTR earning state
     */
    async getChallengesSlugRttrUserStateRaw(requestParameters: GetChallengesSlugRttrUserStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrUserStateResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugRttrUserState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/rttr-user-state`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrUserStateResponseFromJSON(jsonValue));
    }

    /**
     * Returns X-of-X progress counters for all RTTR earning actions.
     * Get authenticated user\'s RTTR earning state
     */
    async getChallengesSlugRttrUserState(requestParameters: GetChallengesSlugRttrUserStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrUserStateResponse> {
        const response = await this.getChallengesSlugRttrUserStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Resolves and returns the shared bulk partner unlock code configured on `segments[segmentIndex]`\'s first PrizePool → RewardConfig → PromoToken.couponCodes[0]. Only returned when the calling user has completed the segment\'s required objectives (ActivityProgression.isComplete === true). 403 with `UNLOCK_GATE_NOT_MET` when the gate is unmet; 404 if the segment or code is missing.
     * Read a segment\'s bulk partner unlock code (gated)
     */
    async getChallengesSlugSegmentsSegmentIndexUnlockCodeRaw(requestParameters: GetChallengesSlugSegmentsSegmentIndexUnlockCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SegmentUnlockCodeResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugSegmentsSegmentIndexUnlockCode().'
            );
        }

        if (requestParameters['segmentIndex'] == null) {
            throw new runtime.RequiredError(
                'segmentIndex',
                'Required parameter "segmentIndex" was null or undefined when calling getChallengesSlugSegmentsSegmentIndexUnlockCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{slug}/segments/{segmentIndex}/unlock-code`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));
        urlPath = urlPath.replace(`{${"segmentIndex"}}`, encodeURIComponent(String(requestParameters['segmentIndex'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SegmentUnlockCodeResponseFromJSON(jsonValue));
    }

    /**
     * Resolves and returns the shared bulk partner unlock code configured on `segments[segmentIndex]`\'s first PrizePool → RewardConfig → PromoToken.couponCodes[0]. Only returned when the calling user has completed the segment\'s required objectives (ActivityProgression.isComplete === true). 403 with `UNLOCK_GATE_NOT_MET` when the gate is unmet; 404 if the segment or code is missing.
     * Read a segment\'s bulk partner unlock code (gated)
     */
    async getChallengesSlugSegmentsSegmentIndexUnlockCode(requestParameters: GetChallengesSlugSegmentsSegmentIndexUnlockCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SegmentUnlockCodeResponse> {
        const response = await this.getChallengesSlugSegmentsSegmentIndexUnlockCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public brand-curated photo showcase for a challenge\'s hub carousel (≤20, ordered by showcaseRank).
     */
    async getChallengesSlugShowcasePhotosRaw(requestParameters: GetChallengesSlugShowcasePhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeShowcasePhotosResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugShowcasePhotos().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/challenges/{slug}/showcase-photos`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeShowcasePhotosResponseFromJSON(jsonValue));
    }

    /**
     * Public brand-curated photo showcase for a challenge\'s hub carousel (≤20, ordered by showcaseRank).
     */
    async getChallengesSlugShowcasePhotos(requestParameters: GetChallengesSlugShowcasePhotosRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeShowcasePhotosResponse> {
        const response = await this.getChallengesSlugShowcasePhotosRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns ranked standings for a challenge. Omit segment for overall (all segments summed); pass segment=N for a specific round.
     * Get challenge standings
     */
    async getChallengesSlugStandingsRaw(requestParameters: GetChallengesSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RttrStandingsResponse>> {
        if (requestParameters['slug'] == null) {
            throw new runtime.RequiredError(
                'slug',
                'Required parameter "slug" was null or undefined when calling getChallengesSlugStandings().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['segment'] != null) {
            queryParameters['segment'] = requestParameters['segment'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['scope'] != null) {
            queryParameters['scope'] = requestParameters['scope'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/challenges/{slug}/standings`;
        urlPath = urlPath.replace(`{${"slug"}}`, encodeURIComponent(String(requestParameters['slug'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RttrStandingsResponseFromJSON(jsonValue));
    }

    /**
     * Returns ranked standings for a challenge. Omit segment for overall (all segments summed); pass segment=N for a specific round.
     * Get challenge standings
     */
    async getChallengesSlugStandings(requestParameters: GetChallengesSlugStandingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RttrStandingsResponse> {
        const response = await this.getChallengesSlugStandingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    async getChallengesSummaryIdRaw(requestParameters: GetChallengesSummaryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChallengeSummaryResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getChallengesSummaryId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userIds'] != null) {
            queryParameters['userIds'] = requestParameters['userIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/summary/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Gets a single Challenge with all of its associated Prize Pools.
     */
    async getChallengesSummaryId(requestParameters: GetChallengesSummaryIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChallengeSummaryResponse> {
        const response = await this.getChallengesSummaryIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Manually remove and replace a winner from a draw log.
     */
    async updateChallengesDrawLogIdRedrawRaw(requestParameters: UpdateChallengesDrawLogIdRedrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateChallengesDrawLogIdRedraw().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/draw-log/{id}/redraw`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RedrawChallengePrizeBodyToJSON(requestParameters['redrawChallengePrizeBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Manually remove and replace a winner from a draw log.
     */
    async updateChallengesDrawLogIdRedraw(requestParameters: UpdateChallengesDrawLogIdRedrawRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateChallengesDrawLogIdRedrawRaw(requestParameters, initOverrides);
    }

    /**
     * Create or update a Challenge
     */
    async updateChallengesIdRaw(requestParameters: UpdateChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Challenge>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateChallengesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengeBodyToJSON(requestParameters['challengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChallengeFromJSON(jsonValue));
    }

    /**
     * Create or update a Challenge
     */
    async updateChallengesId(requestParameters: UpdateChallengesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Challenge> {
        const response = await this.updateChallengesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a user\'s challenge membership
     */
    async updateChallengesIdMembershipRaw(requestParameters: UpdateChallengesIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateChallengesIdMembership().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/{id}/membership`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserChallengeMembershipBodyToJSON(requestParameters['updateUserChallengeMembershipBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a user\'s challenge membership
     */
    async updateChallengesIdMembership(requestParameters: UpdateChallengesIdMembershipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateChallengesIdMembershipRaw(requestParameters, initOverrides);
    }

    /**
     * Updates a challenge prize
     */
    async updateChallengesPrizesIdRaw(requestParameters: UpdateChallengesPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PrizePool>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateChallengesPrizesId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/challenges/prizes/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChallengePrizeBodyToJSON(requestParameters['challengePrizeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PrizePoolFromJSON(jsonValue));
    }

    /**
     * Updates a challenge prize
     */
    async updateChallengesPrizesId(requestParameters: UpdateChallengesPrizesIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PrizePool> {
        const response = await this.updateChallengesPrizesIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirm that the user has been notified of a prize win
     */
    async updateConfirmNotifyPrizeWonIdRaw(requestParameters: UpdateConfirmNotifyPrizeWonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateConfirmNotifyPrizeWonId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/confirm-notify-prize-won/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirm that the user has been notified of a prize win
     */
    async updateConfirmNotifyPrizeWonId(requestParameters: UpdateConfirmNotifyPrizeWonIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateConfirmNotifyPrizeWonIdRaw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const GetChallengeUserReportFormatEnum = {
    Json: 'json',
    Csv: 'csv'
} as const;
export type GetChallengeUserReportFormatEnum = typeof GetChallengeUserReportFormatEnum[keyof typeof GetChallengeUserReportFormatEnum];
/**
 * @export
 */
export const GetChallengesSlugMyRankScopeEnum = {
    Global: 'global',
    UsRace: 'us-race'
} as const;
export type GetChallengesSlugMyRankScopeEnum = typeof GetChallengesSlugMyRankScopeEnum[keyof typeof GetChallengesSlugMyRankScopeEnum];
/**
 * @export
 */
export const GetChallengesSlugStandingsScopeEnum = {
    Global: 'global',
    UsRace: 'us-race'
} as const;
export type GetChallengesSlugStandingsScopeEnum = typeof GetChallengesSlugStandingsScopeEnum[keyof typeof GetChallengesSlugStandingsScopeEnum];
